var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActioms04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7a934f",
    d: "M4.248 3.498a1.67 1.67 0 0 1 1.667-1.67l5.159-.008a1.67 1.67 0 0 1 1.672 1.67v.757h.607a2.428 2.428 0 0 1 2.428 2.429v4.25a1.821 1.821 0 0 1-1.821 1.821h-1.214v.608a1.821 1.821 0 0 1-1.822 1.82H6.067a1.821 1.821 0 0 1-1.821-1.82v-.608H3.03a1.821 1.821 0 0 1-1.821-1.821v-4.25a2.429 2.429 0 0 1 2.429-2.429h.61v-.75zm7.587-.008a.76.76 0 0 0-.76-.76l-5.158.009a.759.759 0 0 0-.758.759v.75h6.676zM6.067 9.408a.91.91 0 0 0-.91.91v3.037a.91.91 0 0 0 .91.91h4.857a.91.91 0 0 0 .911-.91v-3.036a.911.911 0 0 0-.91-.91z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActioms04);
export default __webpack_public_path__ + "static/media/actioms04.b3ec6f12c85a67e2e2f74cb01fc62918.svg";
export { ForwardRef as ReactComponent };